import { Stack } from '@mui/material';
import { IPhones } from 'API/personalDetails';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { useAppSelector, useDictionary, useIsDesktop } from 'Hooks';
import { DataTitle } from '../DataTitle';
import { NavigateTo } from '../NavigateTo';
import { CONTACT_TYPES_ID } from 'Enum/personalDetails';

interface IContactInformation {
  phones: IPhones[];
}

export const ContactInformation = ({ phones }: IContactInformation) => {
  const isDesktop = useIsDesktop();

  const phonePrefixes = useAppSelector(
    ({ generalOptions: { generalOptions } }) => generalOptions
  )?.general?.phonePrefixes;

  const dictionary = useDictionary(Dictionary, DICTIONARY.PersonalDetails);

  const homePhone = phones.find(
    (phone: IPhones) => phone.phoneType === CONTACT_TYPES_ID.home
  );

  const mobilePhone = phones.find(
    (phone: IPhones) => phone.phoneType === CONTACT_TYPES_ID.mobile
  );

  const email = phones.find(
    (phone: IPhones) => phone.phoneType === CONTACT_TYPES_ID.email
  );

  return (
    <Stack gap={'24px'}>
      <Stack
        direction='row'
        flexWrap={'wrap'}
        gap={isDesktop ? '40px' : '20px 10px'}
      >
        <Stack direction='column' width='136px'>
          <DataTitle
            dataTitle={`${dictionary.contactInformation.phone} ${dictionary.contactInformation.mobilePhone}`}
            data={
              mobilePhone?.prefixId && mobilePhone?.phoneNum
                ? `${
                    phonePrefixes?.find(
                      (prefix) => prefix.id === mobilePhone?.prefixId
                    )?.value || ''
                  }-${mobilePhone?.phoneNum}`
                : undefined
            }
          />
        </Stack>
        <Stack direction='column' width='136px'>
          <DataTitle
            dataTitle={`${dictionary.contactInformation.phone} ${dictionary.contactInformation.homePhone}`}
            data={
              homePhone?.prefixId && homePhone?.phoneNum
                ? `${
                    phonePrefixes?.find(
                      (prefix) => prefix.id === homePhone?.prefixId
                    )?.value || ''
                  }-${homePhone?.phoneNum}`
                : undefined
            }
          />
        </Stack>
        <Stack direction='column' width='222px'>
          <DataTitle
            dataTitle={dictionary.contactInformation.email}
            data={email ? email.email : dictionary.noData}
          />
        </Stack>
      </Stack>
      <NavigateTo
        href='/requests/update-personal-details/8/18/1'
        label={dictionary.links.updateContact}
      />
    </Stack>
  );
};
